import { render, staticRenderFns } from "./player.vue?vue&type=template&id=4a7862a3&scoped=true&"
import script from "./player.ts?vue&type=script&lang=js&"
export * from "./player.ts?vue&type=script&lang=js&"
import style0 from "./player.less?vue&type=style&index=0&id=4a7862a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7862a3",
  null
  
)

export default component.exports